module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/title_ribbon_04-8aba2f4df3952b7f81baff9412e2a811.png";